import md5 from 'blueimp-md5';

export default function getSingletonContentId(projectId: string, shapeId: string): string {
  return md5(`${projectId}:${shapeId}`);
}
